<ptl-verification-template
  [title]="titleKey | transloco"
  [buttonName]="buttonNameKey | transloco"
  [showButton]="!verifying"
  (buttonClick)="onButtonClick()"
>
</ptl-verification-template>
